import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import { fromLonLat } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';
import Select from 'ol/interaction/Select';
import Geometry from 'ol/geom/Geometry';
import { Point } from 'ol/geom';
import * as olProj from 'ol/proj';
import { NotificationService } from 'src/app/Service/notification.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import axios from 'src/app/Service/axios';
import { BingMaps, XYZ } from 'ol/source';


declare let $: any;

@Component({

  selector: 'app-analyze-bubble-map',

  templateUrl: './analyze-bubble-map.component.html',

  styleUrls: ['./analyze-bubble-map.component.css']

})

export class AnalyzeBubbleMapComponent implements OnInit {

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  map!: Map;

  layers: any = [];

  tooltipData: any;

  source: any;

  vector: any;

  radiusScale = 0.01;

  lst_Result: any = [];

  lst_Analyze: any = [];

  lst_Search: any = [];

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService,

    private _gurd: GurdServiceService,


  ) { }

  ngOnInit(): void {

    if (localStorage.getItem('bubbleMap_date')) {

      this.lst_Result = JSON.parse(this._gurd.decrypt(localStorage.getItem('bubbleMap_date')!));

      this.initializeMap();

    }

  }

  ngAfterViewInit() {

    setTimeout(() => {

      this.map.on('pointermove', (e: any) => {

        if (e.dragging) {

          //...

          return;

        }

        var el = this.mapService.mapPointerMove(this.map.getEventPixel(e.originalEvent), this.map);

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = hit ? 'pointer' : '';

      });

      this.map.getView().on('propertychange', (e: any) => {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

      });

    }, 500);

  }

  initializeMap() {

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)

      }

      this.map = new Map({

        target: "bubble_map",

        layers: this.layers,

        view: new View({

          zoom: this.bOfflineMap ? 14 : 6,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

      });

      if (!this.lst_Result.length) {

        return this._tooltip.showInfo('داده ایی برای نمایش وجود ندارد', 'داده‌ای یافت نشد')

      }

      const vectorLayer = this.createBubbleLayer();

      this.map.addLayer(vectorLayer);

      this.addSelectInteraction(vectorLayer);

      this.addTooltip();

      this.fitMapToCluster();


    }, 300);

  }

  createBubbleLayer(): VectorLayer<VectorSource> {
    const features = this.lst_Result.map(item => {
      const feature = new Feature({
        geometry: new Point(fromLonLat([item.CenterLon, item.CenterLat])),
        TotalDischarge: item.TotalDischarge,
        iRadius: item.iRadius,
        striTanker_Discharges: item.striTanker_Discharges
      });

      return feature as Feature<Geometry>;
    });

    const source = new VectorSource({ features });

    return new VectorLayer({
      source,
      style: feature => this.bubbleStyle(feature)
    });
  }

  bubbleStyle(feature: any) {

    const value = feature.get('iRadius');

    const radius = Math.sqrt(value) * 1.2;

    const TotalDischarge = feature.get('TotalDischarge')

    const color = this.getBubbleColor(TotalDischarge);

    return new Style({
      image: new CircleStyle({
        radius,
        fill: new Fill({ color }),
        stroke: new Stroke({
          color: '#fff',
          width: 2
        })
      }),
      text: new Text({
        text: TotalDischarge.toLocaleString(),
        font: 'bold 12px vazir',
        fill: new Fill({ color: '#fff' }),
        stroke: new Stroke({ color: '#000', width: 3 })
      })
    });

  }

  getBubbleColor(dischargeAmount: number): string {

    if (dischargeAmount <= 1000) {
      return 'rgba(25, 135, 84, 0.6)';   // سبز تیره
    }
    if (dischargeAmount <= 2000) {
      return 'rgba(40, 167, 69, 0.6)';   // سبز
    }
    if (dischargeAmount <= 3000) {
      return 'rgba(72, 180, 97, 0.6)';   // سبز روشن
    }
    if (dischargeAmount <= 4000) {
      return 'rgba(173, 181, 62, 0.6)';  // سبز مایل به زرد
    }
    if (dischargeAmount <= 5000) {
      return 'rgba(255, 193, 7, 0.6)';   // زرد
    }
    if (dischargeAmount <= 6000) {
      return 'rgba(255, 170, 51, 0.6)';  // زرد-نارنجی
    }
    if (dischargeAmount <= 7000) {
      return 'rgba(255, 140, 0, 0.6)';   // نارنجی
    }
    if (dischargeAmount <= 8000) {
      return 'rgba(255, 120, 0, 0.6)';   // نارنجی پررنگ
    }
    if (dischargeAmount <= 9000) {
      return 'rgba(255, 99, 71, 0.6)';   // نارنجی مایل به قرمز
    }
    if (dischargeAmount <= 10000) {
      return 'rgba(255, 69, 0, 0.6)';    // قرمز روشن
    }

    return 'rgba(220, 53, 69, 0.6)';       // قرمز تیره (بحرانی)

  }

  addSelectInteraction(layer: VectorLayer<VectorSource<Geometry>>) {

    const select = new Select({ layers: [layer] });

    this.map.addInteraction(select);

    select.on('select', e => {
      if (!e.selected.length) return;

      const feature = e.selected[0];
      const tankerIds = feature.get('striTanker_Discharges');

      this.openPopup(tankerIds);
    });


  }

  addTooltip() {

    this.map.on('pointermove', evt => {

      const feature = this.map.forEachFeatureAtPixel(

        evt.pixel,

        f => f

      );

      if (feature) {

        const val = feature.get('TotalDischarge');

        var tooltip = $('#map_tooltips');

        tooltip.tooltip({

          html: true,

          animation: true,

          trigger: 'manual',

          placement: 'top',

        });

        tooltip.html(`جمع کل تخلیه (لیتر): ${val.toLocaleString()}`)

        tooltip.css({

          left: evt.pixel[0] - 65 + 'px',

          top: evt.pixel[1] - 40 + 'px',

          zindex: 10000,

        }).show();

      }

      else {

        $('#map_tooltips').hide();

      }

    });

  }

  fitMapToCluster() {

    const coordinates = this.lst_Result.map(item => {

      return { fLon: item.CenterLon, fLat: item.CenterLat }

    });

    this.mapService.fitMap(coordinates, this.map);

  }

  async openPopup(tankerIds: string) {

    let model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      striTanker_Discharges: tankerIds

    }

    this._otherService.Showspinner()

    let res = JSON.parse((await axios.post(`Tanker_DischargeAnalyze_Info`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Analyze = res;

    this.lst_Search = res;

    $('#map_tooltips').hide();

    $("#view_Modal").modal("show");


  }

  filter_list(val: any) {

    this.lst_Analyze = this.lst_Search.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strAddress.includes(val.value) ||

        el.strDate.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Analyze = this.lst_Search;

    }

  }

}
